import { EventParentalControlRating } from 'services/data-manager/types';

const parentalControlRatingNumbers = {
    [EventParentalControlRating.UNKNOWN]: 0,
    [EventParentalControlRating.HU_GENERAL]: 0,
    [EventParentalControlRating.HU_UNRATED]: 0,
    [EventParentalControlRating.HU6]: 6,
    [EventParentalControlRating.HU12]: 12,
    [EventParentalControlRating.HU16]: 16,
    [EventParentalControlRating.HU18]: 18,
    [EventParentalControlRating.HU18_ADULT]: 100,
    [EventParentalControlRating.HU18_ADULT_UC]: 101,
};

export const getParentalControlRatingNumbers = (
    parentalControlRating?: EventParentalControlRating,
) => {
    if (!parentalControlRating) {
        return 0;
    }

    return parentalControlRatingNumbers[parentalControlRating];
};
